document.addEventListener('DOMContentLoaded', (e) => {
	// simple tabs show/hide
	// Individuals
	if (document.querySelector('#tab-musa-individual')) {
		jQuery(once('musaInd','#tab-musa-individual'))
			.click(function (e) {
				e.preventDefault();
				jQuery('.view-display-id-block_musa_ind').triggerHandler('RefreshView');
				jQuery('#tab-musa-twitter').removeClass('selected');
				jQuery(this).addClass('selected');
				jQuery('#grid-tab-musa-individual').show();
				jQuery('#grid-tab-musa-twitter').hide();
			});
	}

	// twitter
	if (document.querySelector('#tab-musa-twitter')) {
		jQuery(once('musaTwitter','#tab-musa-twitter'))
			.click(function (e) {
				e.preventDefault();
				jQuery('.view-display-id-block_musa_twitter').triggerHandler(
					'RefreshView'
				);
				jQuery('#tab-musa-individual').removeClass('selected');
				jQuery(this).addClass('selected');
				jQuery('#grid-tab-musa-individual').hide();
				jQuery('#grid-tab-musa-twitter').show();
			});
	}

	jQuery(
		'.view-ahmad-musa-jibril-taxonomy-grid .views-field-field-musa-image a'
	).click(function (e) {
		e.preventDefault();
	});
});
